import { activityService } from '@/services/activityService'
import type { CreateActivityData } from '@/types'

interface ActivityLoggerOptions {
  userId: number
  action: 'created' | 'updated' | 'deleted' | 'viewed'
  entity: string
  entityId?: number
  entityName?: string
  description?: string
  source?: 'web' | 'api'
  metadata?: Record<string, any>
}

export class ActivityLogger {
  static async log(options: ActivityLoggerOptions): Promise<void> {
    try {
      const { userId, action, entity, entityId, entityName, description, source = 'web', metadata } = options
      
      const activityDescription = description || this.generateDescription(action, entity, entityName)
      
      const activityData: CreateActivityData = {
        userId,
        action,
        entity,
        entityId,
        entityName,
        description: activityDescription,
        source,
        metadata
      }
      
      await activityService.createActivity(activityData)
    } catch (error) {
      console.error('Error logging activity:', error)
      // Don't throw error to avoid breaking the main operation
    }
  }
  
  private static generateDescription(action: string, entity: string, entityName?: string): string {
    const entityDisplayName = entityName || `${entity} item`
    
    switch (action) {
      case 'created':
        return `Creó ${entityDisplayName} en ${entity}`
      case 'updated':
        return `Actualizó ${entityDisplayName} en ${entity}`
      case 'deleted':
        return `Eliminó ${entityDisplayName} de ${entity}`
      case 'viewed':
        return `Visualizó ${entityDisplayName} en ${entity}`
      default:
        return `Realizó acción ${action} en ${entityDisplayName}`
    }
  }
  
  // Convenience methods for common operations
  static async logCreate(userId: number, entity: string, entityId: number, entityName: string, source: 'web' | 'api' = 'web', metadata?: Record<string, any>) {
    await this.log({
      userId,
      action: 'created',
      entity,
      entityId,
      entityName,
      source,
      metadata
    })
  }
  
  static async logUpdate(userId: number, entity: string, entityId: number, entityName: string, source: 'web' | 'api' = 'web', metadata?: Record<string, any>) {
    await this.log({
      userId,
      action: 'updated',
      entity,
      entityId,
      entityName,
      source,
      metadata
    })
  }
  
  static async logDelete(userId: number, entity: string, entityId: number, entityName: string, source: 'web' | 'api' = 'web', metadata?: Record<string, any>) {
    await this.log({
      userId,
      action: 'deleted',
      entity,
      entityId,
      entityName,
      source,
      metadata
    })
  }
}